const initialState = {
  codbf: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BF_COD":
      return {
        ...state,
        codbf: action.payload,
      };
    default:
      return state;
  }
}
